import { useState } from "react";
import { useBeforeAfter } from "@/lib/queries";
import SectionHeading from "@/components/SectionHeading";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";
import { Reveal } from "@/components/Reveal";

export default function BeforeAfterSection() {
  const { data: items = [] } = useBeforeAfter();
  const [active, setActive] = useState(0);

  if (!items.length) return null;
  const current = items[Math.min(active, items.length - 1)];

  return (
    <section data-testid="before-after-section" className="border-y border-white/10 bg-black py-24 sm:py-32">
      <div className="container-x">
        <SectionHeading
          number="02"
          overline="Öncesi / Sonrası"
          title="Sonuçlar kendini gösterir"
          subtitle="Çubuğu sürükleyerek uygulamalarımızın yarattığı farkı kendi gözlerinizle görün."
          align="center"
        />
        <Reveal className="mx-auto mt-14 max-w-4xl">
          <BeforeAfterSlider before={current.before_image} after={current.after_image} alt={current.title} />
          <div className="mt-6 flex flex-wrap justify-center gap-2.5">
            {items.map((it, i) => (
              <button
                key={it.id || i}
                data-testid={`before-after-tab-${i}`}
                onClick={() => setActive(i)}
                className={`border px-4 py-2 font-oswald text-xs uppercase tracking-[0.15em] transition-colors ${
                  i === active ? "border-gold bg-gold/10 text-gold" : "border-white/10 text-neutral-400 hover:border-gold/30 hover:text-white"
                }`}
              >
                {it.title}
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
